// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"9bab7257","255":"b5170080"}[chunkId] + ".chunk.js";
};